import { Button } from "@mui/joy";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useRecoilState, useRecoilValue } from "recoil";
import { sendMessage } from "utils/webview";
import useIsInappWebview from "hooks/useIsInappWebview";
import useGetEventFromApp from "hooks/useGetEventFromApp";
import { useCallback, useEffect, useState } from "react";
import { USER_DETAIL_ENDPOINT, USER_DOMAIN, userApi } from "api/userApi";
import { paymentOrderAtom } from "recoil/paymentOrderAtom";
import { PATH } from "routes/paths";
import { useNavigate } from "react-router-dom";
import useMixpanelWeb from "hooks/useMixpanelWeb";
import { PlanKey } from "../planTypes";
import { axiosInstance } from "../../../../api";
import { userAtom } from "../../../../recoil/userAtom";

export default function PlanUpgradeButton({
  currentPlan,
  nextPlan,
}: {
  currentPlan: PlanKey;
  nextPlan: PlanKey;
}) {
  const isInappWebview = useIsInappWebview();

  const navigate = useNavigate();
  const [user, setUser] = useRecoilState(userAtom);
  const paymentOrderState = useRecoilValue(paymentOrderAtom);
  const parsedMessageFromApp = useGetEventFromApp();
  const queryClient = useQueryClient();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isDone, setIsDone] = useState<boolean>(false); //중복 방지
  const [disabled, setDisabled] = useState<boolean>(false);

  const setMixPanel = useMixpanelWeb({
    eventName: "프로그램 변경하기 버튼 클릭",
  });

  useQuery(
    [USER_DOMAIN, USER_DETAIL_ENDPOINT],
    useCallback(() => userApi.getDetail(), []),
    {
      enabled:
        !!axiosInstance.defaults.headers["X-Auth-Token"] && !!user?.accessToken,

      onSuccess: (data) => {
        if (data && data.result) {
          //결제 탭 닫기
          if (data.result.subscription?.hasBeenPlanUpgraded) {
            setDisabled(true);
          }

          setUser((user) => ({
            ...user,
            ...data.result,
          }));
        }
      },
    }
  );

  useEffect(() => {
    if (parsedMessageFromApp?.event === "payment") {
      const status = parsedMessageFromApp.params.status;
      if (status) {
        setIsLoading(false);
        if (status === "success" && !isDone) {
          queryClient.invalidateQueries([USER_DOMAIN, USER_DETAIL_ENDPOINT]);
          setIsDone(true);
        }
      }
    }
  }, [parsedMessageFromApp]);

  const buttonText = "프로그램 변경하기";

  const requestPayment = () => {
    if (paymentOrderState) {
      if (paymentOrderState?.paymentProvider === "toss_payments") {
        if (isInappWebview) {
          setIsLoading(true);

          sendMessage(
            JSON.stringify({
              event: "request_toss_payments",
              params: {
                url: `${window.location.origin}${PATH.tossPaymentsPlanUpgrade}?previous_plan=${currentPlan}&new_plan=${nextPlan}`,
              },
            })
          );

          setTimeout(() => {
            setIsLoading(false);
          }, 3000);
        } else {
          navigate(
            `${PATH.tossPaymentsPlanUpgrade}?previous_plan=${currentPlan}&new_plan=${nextPlan}`
          );
        }
      }

      setMixPanel();
    }
  };

  return (
    <Button
      loading={isLoading}
      disabled={disabled}
      onClick={requestPayment}
      size={"lg"}
      color={"primary"}
      sx={{ width: "100%", fontWeight: 700 }}
    >
      {buttonText}
    </Button>
  );
}
